import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-check-circle-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 0.666626C3.94991 0.666626 0.666666 3.94987 0.666666 7.99996C0.666666 12.05 3.94991 15.3333 8 15.3333C12.0501 15.3333 15.3333 12.05 15.3333 7.99996C15.3333 3.94987 12.0501 0.666626 8 0.666626ZM11.4714 6.47136C11.7318 6.21101 11.7318 5.7889 11.4714 5.52855C11.2111 5.26821 10.7889 5.26821 10.5286 5.52855L7 9.05715L5.4714 7.52855C5.21105 7.2682 4.78894 7.2682 4.52859 7.52855C4.26825 7.7889 4.26825 8.21101 4.52859 8.47136L6.52859 10.4714C6.78894 10.7317 7.21105 10.7317 7.4714 10.4714L11.4714 6.47136Z"
        [attr.fill]="color"
      />
    </svg>
  `,
})
export class CheckCircleIcon extends BaseIconComponent {}
